<a href="{{socialNetworks.facebook}}" target="_blank" *ngIf="socialNetworks.facebook">
  <i class="lvi-thel-facebook"></i>
</a>
<a href="{{socialNetworks.instagram}}" target="_blank" *ngIf="socialNetworks.instagram">
  <i class="lvi-thel-instagram"></i>
</a>
<a href="{{socialNetworks.linkedin}}" target="_blank" *ngIf="socialNetworks.linkedin">
  <i class="lvi-thel-linkedin"></i>
</a>
<a href="{{socialNetworks.tiktok}}" target="_blank" *ngIf="socialNetworks.tiktok">
  <i class="lvi-thel-tiktok"></i>
</a>
<a href="{{socialNetworks.x}}" target="_blank" *ngIf="socialNetworks.x">
  <i class="lvi-thel-twitter-x"></i>
</a>
<a href="{{socialNetworks.youtube}}" target="_blank" *ngIf="socialNetworks.youtube">
  <i class="lvi-thel-youtube"></i>
</a>
